import React from "react";
import {
  ApiGeneralDataResponse,
  EditSignalLimits,
  FormattedChartDataPoint,
  GetExchangeSignalByIdRequest,
  GetSignalByIdRequest,
  LineAnnotation,
  PointAnnotation,
  PrecisionConfig,
  PriceGraphData,
  ProcessedSignalTargets,
  QueryStatus,
  SignalExtraDetailsConfiguration,
  SignalGeneralExtraData,
  SignalGraphRequest,
  TimeRange,
  TradeExtraInfoActivity,
} from "@shared/types";
import { ValueOf } from "@shared/types/utils";
import { SIGNAL_EXTRA_DETAILS_TABS } from "@shared/common/constants";
import { EditTargetOrZone } from "@shared/features/signals/EditSignal/types";

export const SignalDetailsContext = React.createContext<
  | {
      isEdit: boolean;
      signalId?: number;
      tab?: ValueOf<typeof SIGNAL_EXTRA_DETAILS_TABS>;
      baseArgs?: GetSignalByIdRequest;
      exchangeSignalArgs?: GetExchangeSignalByIdRequest;
      generalDataQuery: QueryStatus<
        SignalGeneralExtraData,
        GetExchangeSignalByIdRequest
      >;
      configurationQuery: QueryStatus<
        ApiGeneralDataResponse<SignalExtraDetailsConfiguration>,
        GetSignalByIdRequest
      >;
      getMostFulfilledSignalForGroupQuery: QueryStatus<
        { exchange_signal_id: number },
        GetSignalByIdRequest
      >;
      getSignalExtraInfoTargetsQuery: QueryStatus<
        ApiGeneralDataResponse<ProcessedSignalTargets, EditSignalLimits>,
        GetExchangeSignalByIdRequest
      >;
      getPriceGraphDataQuery: QueryStatus<
        ApiGeneralDataResponse<PriceGraphData>,
        SignalGraphRequest
      >;
      getSignalExtraInfoActivitiesQuery: QueryStatus<
        TradeExtraInfoActivity[],
        GetExchangeSignalByIdRequest
      >;
      getExchangeSignalIdsQuery: QueryStatus<
        Record<string, number>,
        GetSignalByIdRequest
      >;
      selectedTimeRange: TimeRange;
      setSelectedTimeRange: (timeRange: TimeRange) => void;
      selectedExchange?: string;
      setSelectedExchange: (exchange: string) => void;
      signalExchanges: string[];
      forAdmin?: boolean;
      priceCoin?: string;
      pricePrecision: number;
      precisionConfig?: PrecisionConfig;
      priceGraphData: FormattedChartDataPoint[];
      currentPrice?: number;
      targets?: {
        entryTargets: EditTargetOrZone[];
        takeProfitTargets: EditTargetOrZone[];
        stopTargets: EditTargetOrZone[];
      };
      activitiesAnnotations: PointAnnotation[];
      targetsAnnotations: LineAnnotation[];
      symbol?: string;
      showEditSignalActions?: boolean;
    }
  | undefined
>(undefined);
